import { render, staticRenderFns } from "./FilterPanel.vue?vue&type=template&id=45c1513a&scoped=true"
import script from "./FilterPanel.vue?vue&type=script&lang=js"
export * from "./FilterPanel.vue?vue&type=script&lang=js"
import style0 from "./FilterPanel.vue?vue&type=style&index=0&id=45c1513a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1513a",
  null
  
)

export default component.exports